import React from 'react';
import "./HomeStaging.css";
import images from "../../constants/images";

const HomeStaging = () => {
  const rooms = [
    { image: images.room1, alt: "Habitación 1" },
    { image: images.room2, alt: "Habitación 2" },
    { image: images.room3, alt: "Habitación 3" },
    { image: images.room4, alt: "Habitación 4" },
    { image: images.room5, alt: "Habitación 5" },
    { image: images.room6, alt: "Habitación 6" }
  ];

  return (
    <div className='homestaging section-p' id="homestaging">
      <div className='container'>
        <div className='homestaging-content'>
          <div className='section-title'>
            <h3 className='text-brown'>Nuestro <span className='text-dark'>Trabajo</span></h3>
            <p className='text'>Descubre cómo transformamos propiedades con nuestro servicio de home staging profesional. Antes y después de habitaciones que cuidamos como si fueran nuestras.</p>
          </div>

          <div className='homestaging-gallery grid'>
            {rooms.map((room, index) => (
              <div className='gallery-item' key={index}>
                <img src={room.image} alt={room.alt} className='gallery-img' />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeStaging;